function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Container, FlexboxContainer, CssContainer } from "../../components/container";
import { PageHeader, Ribbon, Card, Pill, Empty, Search, Filters, Delta, Pending } from "../../components/analytics-kit";

// territory-common deltas ({text, dir, pct}) in the kit's shape; null stays null ("no comparison").
const kitDelta = d => d && d.pct != null ? {
  dir: d.dir,
  pct: d.pct
} : null;
import ComparisonPicker from "../../components/comparison-picker";
import StatusFilter from "../../components/status-filter";
import PlunkDropDown from "../../components/plunk-dropdown";
import { Loader, ChartLoader } from "../../components/loaders";
import Error from "../../components/error";
import Chart from "../../components/chart";
import { hasTenantFeature } from "../../functions/tenant-features";
import { rangeLabelFor, RANGES, num, usd, aov, fetchSales, bucketFor, trendLabel, deltaOf, deltaOfPaced, comparisonQs, hasPrevTrend, channelLabel } from "./territory-common";
import compLabel from "../../functions/comp-label";
import { getGlobalRange, getGlobalComp, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";

/*
 * Sales Channel Detail — the Fairfield demo ask (spec: TERRITORY_REP
 * spec, "Sales by Channel" 2026-07-30). Scope = one REP channel
 * (commercial / residential / senior living / unsegmented) — who SELLS,
 * distinct from lifecycle b2b/b2c (who buys).
 *
 * Attribution: sale → dealer → dealer.assigned_rep_id → rep's channel,
 * resolved server-side (Service.Product 1.1.34). Server-scoped via
 * `channel=` on /totals, /trend, /customers, /products; the reps roster
 * ignores `channel=` so "Reps in this Channel" filters the roster rows'
 * own `channel` field client-side (bounded — it's the full roster).
 * The unscoped /totals call feeds the Share-of-Total tile.
 */

class ChannelDetailViewComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onRange", e => {
      this.props.history.push(`/Territory/${e.target.value}/channel/${encodeURIComponent(this.channel())}`);
    });
    _defineProperty(this, "onCompSelected", e => {
      const comp = e.detail.item.dataset.value;
      if (comp === "unavailable" || comp === this.state.comp) return;
      this.setState({
        comp,
        data: null,
        error: false
      }, () => this.load());
    });
    _defineProperty(this, "back", () => {
      this.props.history.push(`/Territory/${this.range()}`);
    });
    _defineProperty(this, "openRep", repCode => {
      if (!repCode) return;
      this.props.history.push(`/Territory/${this.range()}/rep/${encodeURIComponent(repCode)}`);
    });
    _defineProperty(this, "openCustomer", accountNumber => {
      if (!accountNumber) return;
      this.props.history.push(`/Territory/${this.range()}/customer/${encodeURIComponent(accountNumber)}`);
    });
    _defineProperty(this, "openProduct", p => {
      if (!p || !p.productId) return;
      this.props.history.push({
        pathname: `/Territory/${this.range()}/product/${encodeURIComponent(p.productId)}`,
        state: p.title ? {
          title: p.title
        } : undefined
      });
    });
    this.state = {
      data: null,
      error: false,
      status: [],
      comp: getGlobalComp("prev_period")
    };
    this._alive = true;
  }
  range() {
    return this.props.params && this.props.params.range || getGlobalRange();
  }
  channel() {
    return decodeURIComponent(this.props.params && this.props.params.channel || "");
  }
  componentDidMount() {
    this.load();
    this._periodTok = subscribePeriod(({
      range,
      comp
    }) => {
      if (!this._alive || !range) return;
      if (comp && comp !== this.state.comp) this.setState({
        comp
      });
      const target = `/Territory/${range}/channel/${encodeURIComponent(this.channel())}`;
      if (window.location.pathname === target) {
        this.setState({
          data: null,
          error: false
        }, () => this.load());
      } else {
        this.props.history.push(target);
      }
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
  }
  componentDidUpdate(prev) {
    const prevKey = `${prev.params && prev.params.range || ""}|${prev.params && prev.params.channel || ""}`;
    const key = `${this.props.params && this.props.params.range || ""}|${this.props.params && this.props.params.channel || ""}`;
    if (prevKey !== key) {
      this.setState({
        data: null,
        error: false
      });
      this.load();
    }
  }
  async load() {
    const range = this.range();
    const comp = this.state.comp;
    const ch = encodeURIComponent(this.channel());
    const bucket = bucketFor(range);
    const st = (this.state.status || []).join(",");
    const ws = u => st ? u + (u.includes("?") ? "&" : "?") + "status=" + encodeURIComponent(st) : u;
    try {
      const [totals, allTotals, trend, reps, customers, topProducts] = await Promise.all([fetchSales(ws(`/sales/totals/${range}?channel=${ch}${comparisonQs(range, false, comp)}`)), fetchSales(ws(`/sales/totals/${range}`)), fetchSales(ws(`/sales/trend/${range}?bucket=${bucket}&channel=${ch}${comparisonQs(range, false, comp)}`)), fetchSales(`/sales/reps/${range}`), fetchSales(ws(`/sales/customers/${range}?channel=${ch}&top=100`)), fetchSales(ws(`/sales/products/${range}?channel=${ch}&top=15`)).catch(() => [])]);
      if (this._alive) this.setState({
        data: {
          totals,
          allTotals,
          trend,
          reps,
          customers,
          topProducts,
          bucket
        }
      });
    } catch (e) {
      if (this._alive) this.setState({
        error: true
      });
    }
  }
  trendChartData(trend, bucket) {
    if (!trend || trend.length < 2) return null;
    const withPrev = hasPrevTrend(trend);
    const data = [withPrev ? ["Period", "Revenue", "Prev Revenue", "Orders", "Prev Orders"] : ["Period", "Revenue", "Orders"]];
    trend.forEach(t => {
      const rev = Math.round((Number(t.totalAmount) || 0) * 100) / 100;
      const second = Number(t.orders) || 0;
      if (withPrev) data.push([trendLabel(t.period, bucket), rev, Math.round((Number(t.prevTotalAmount) || 0) * 100) / 100, second, Number(t.prevOrders) || 0]);else data.push([trendLabel(t.period, bucket), rev, second]);
    });
    data.withPrev = withPrev;
    return data;
  }
  render() {
    if (!hasTenantFeature("territoryRep")) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "Territory & Rep Intelligence is not configured for this workspace."));
    }
    const {
      data,
      error
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    if (!data) return /*#__PURE__*/React.createElement(Loader, null);
    const channel = this.channel();
    const label = channelLabel(channel);
    const unsegmented = String(channel).toLowerCase() === "unsegmented";
    const norm = v => String(v || "").trim().toLowerCase();
    const {
      totals,
      allTotals,
      trend,
      reps,
      customers,
      topProducts,
      bucket
    } = data;
    const inChannel = reps.filter(r => unsegmented ? !r.channel : norm(r.channel) === norm(channel));
    const selling = inChannel.filter(r => r.orders > 0);
    const dormant = inChannel.filter(r => !r.orders);
    const allRev = Number(allTotals.totalAmount) || 0;
    const share = allRev > 0 ? `${((Number(totals.totalAmount) || 0) / allRev * 100).toFixed(1)}%` : "—";
    const chartData = this.trendChartData(trend, bucket);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view territory-detail channel-detail wa-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: `/Territory/${this.range()}`
      }, "Territory & Reps"), " \xB7 Sales channel"),
      title: label,
      subtitle: `${rangeLabelFor(this.range(), RANGES)} · sales attributed by the selling rep's channel tag · deltas are paced vs the previous period`,
      chips: [{
        k: "Share of total",
        v: share
      }, {
        k: "Reps",
        v: num(inChannel.length)
      }],
      actions: /*#__PURE__*/React.createElement(StatusFilter, {
        range: this.range(),
        value: this.state.status,
        onChange: v => this.setState({
          status: v,
          data: null,
          error: false
        }, () => this.load())
      })
    }), unsegmented && /*#__PURE__*/React.createElement("div", {
      className: "wa-notice"
    }, "Sales attributed to reps without a channel tag. Tag those reps in the sales-rep feed and their sales move to the right channel on the next feed run."), /*#__PURE__*/React.createElement(Ribbon, {
      comparing: true,
      cols: 4,
      tiles: [{
        l: "Revenue",
        v: usd(totals.totalAmount),
        d: kitDelta(deltaOfPaced(totals.totalAmount, totals.prevTotalAmount, this.range())),
        s: `${share} of all revenue`
      }, {
        l: "Orders",
        v: num(totals.orders),
        d: kitDelta(deltaOfPaced(totals.orders, totals.prevOrders, this.range())),
        s: `${aov(totals.totalAmount, totals.orders)} average order`
      }, {
        l: "Dealers buying",
        v: num(totals.customers),
        d: kitDelta(deltaOfPaced(totals.customers, totals.prevCustomers, this.range()))
      }, {
        l: "Reps",
        v: num(inChannel.length),
        s: `${num(selling.length)} selling this period`
      }]
    }), /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, chartData && /*#__PURE__*/React.createElement(Card, {
      title: "Sales trend",
      hint: "revenue bars \xB7 orders line \xB7 dashed = prior period when a comparison is set"
    }, /*#__PURE__*/React.createElement("div", {
      className: "territory-trend"
    }, /*#__PURE__*/React.createElement(Chart, {
      width: "100%",
      height: "320px",
      chartType: "ComboChart",
      loader: /*#__PURE__*/React.createElement(ChartLoader, null),
      data: chartData,
      options: {
        seriesType: "bars",
        series: chartData.withPrev ? {
          0: {
            targetAxisIndex: 0,
            color: "#ff6358" /* accent */,
            tooltipFormat: "currency"
          },
          1: {
            type: "line",
            targetAxisIndex: 0,
            color: "#aa46be" /* palette purple */,
            lineDashStyle: [4, 3],
            tooltipFormat: "currency"
          },
          2: {
            type: "line",
            targetAxisIndex: 1,
            color: "#78d237" /* palette green */,
            tooltipFormat: "{0:n0}"
          },
          3: {
            type: "line",
            targetAxisIndex: 1,
            color: "#ffd246" /* palette yellow */,
            lineDashStyle: [4, 3],
            tooltipFormat: "{0:n0}"
          }
        } : {
          0: {
            targetAxisIndex: 0,
            color: "#ff6358" /* accent */,
            tooltipFormat: "currency"
          },
          1: {
            type: "line",
            targetAxisIndex: 1,
            color: "#78d237" /* palette green */,
            tooltipFormat: "{0:n0}"
          }
        },
        vAxes: {
          0: {
            title: "Revenue",
            format: "short"
          },
          1: {
            title: "Orders",
            format: "0"
          }
        },
        legend: {
          position: "top"
        },
        backgroundColor: "transparent",
        chartArea: {
          left: 70,
          right: 60,
          top: 40,
          bottom: 40
        }
      }
    }))), /*#__PURE__*/React.createElement(Card, {
      title: "Reps in this channel",
      hint: "selling this period, then reps with no sales \xB7 click a rep for their performance"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Rep"), /*#__PURE__*/React.createElement("th", null, "Territory"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Accounts"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Orders"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Dealers Sold"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Units"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Revenue"))), /*#__PURE__*/React.createElement("tbody", null, selling.map(r => /*#__PURE__*/React.createElement("tr", {
      key: r.repCode,
      className: "clickable" + (r.status === "terminated" ? " terminated" : ""),
      onClick: () => this.openRep(r.repCode),
      title: `Open ${r.name || r.repCode} rep performance`
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, r.name), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, r.repCode, r.status === "terminated" ? " · terminated" : "")), /*#__PURE__*/React.createElement("td", {
      className: "states"
    }, r.states || "—", r.postalCodes ? ` (+${r.postalCodes} ZIPs)` : ""), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.assignedAccounts)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.orders)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.customers)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.quantity)), /*#__PURE__*/React.createElement("td", {
      className: "n strong"
    }, usd(r.totalAmount)))), dormant.map(r => /*#__PURE__*/React.createElement("tr", {
      key: r.repCode,
      className: "dormant clickable",
      onClick: () => this.openRep(r.repCode)
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, r.name), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, r.repCode)), /*#__PURE__*/React.createElement("td", {
      className: "states"
    }, r.states || "—"), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.assignedAccounts)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, "0"), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, "0"), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, "0"), /*#__PURE__*/React.createElement("td", {
      className: "n dim"
    }, "\u2014")))))), inChannel.length === 0 && /*#__PURE__*/React.createElement(Empty, null, "No reps carry this channel tag.")), (topProducts || []).length > 0 && /*#__PURE__*/React.createElement(Card, {
      title: "Top products",
      hint: "by revenue \xB7 click a product for its detail",
      span: 6
    }, /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Product"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Orders"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Units"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Revenue"))), /*#__PURE__*/React.createElement("tbody", null, topProducts.map(p => /*#__PURE__*/React.createElement("tr", {
      key: p.productId,
      className: "clickable cust-row",
      onClick: () => this.openProduct(p),
      title: `Open ${p.title || p.productId} product detail`
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, p.title || p.productId), " ", /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, p.productId)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(p.orders)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(p.quantity)), /*#__PURE__*/React.createElement("td", {
      className: "n strong"
    }, usd(p.totalAmount)))))))), /*#__PURE__*/React.createElement(Card, {
      title: "Top dealers in this channel",
      hint: "by revenue \xB7 click a dealer for its detail",
      span: (topProducts || []).length > 0 ? 6 : 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Dealer"), /*#__PURE__*/React.createElement("th", null, "Location"), /*#__PURE__*/React.createElement("th", null, "Assigned Rep"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Orders"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Units"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Revenue"))), /*#__PURE__*/React.createElement("tbody", null, customers.map(c => /*#__PURE__*/React.createElement("tr", {
      key: c.accountNumber,
      className: "clickable",
      onClick: () => this.openCustomer(c.accountNumber),
      title: `Open ${c.name} customer detail`
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, c.name), /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, c.accountNumber)), /*#__PURE__*/React.createElement("td", null, [c.city, c.region].filter(Boolean).join(", ") || "—"), /*#__PURE__*/React.createElement("td", null, c.assignedRepName || c.assignedRepId || "—"), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(c.orders)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(c.quantity)), /*#__PURE__*/React.createElement("td", {
      className: "n strong"
    }, usd(c.totalAmount))))))), customers.length === 0 && /*#__PURE__*/React.createElement(Empty, null, "No dealer sales in this channel this period."))));
  }
}
export default withRouter(ChannelDetailViewComponent);